import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import NobulaLogoIcon from '../../../../assets/icons/NobulaLogo.svg';
import Points from '../../../components/widget/Points';
import Timer from '../../../components/widget/timer';
import {loadedPresentationSelector} from '../../../store/selectors/presentation.selectors';
import LeaderBoard from '../../../components/widget/Leaderboard';
import {usePresentationMode} from '../../../hooks/usePresentationMode';
import HeaderMenu from './HeaderMenu';
import Button from '../../../incase-domain/components/button/Button';
import {openEndPresentationAction} from '../../../store/actions/chalkBoardElements.actions';

interface MobileHeaderProps {
    hasPresActions?: boolean;
    tabletScreenSize?: boolean;
    inLobby?: boolean;
}

function MobileHeader({hasPresActions = false, tabletScreenSize = false, inLobby = false}: MobileHeaderProps): JSX.Element {
    const dispatch = useDispatch();

    const presentation = useSelector(loadedPresentationSelector);
    const {showTimer, showLeaderboard} = usePresentationMode();

    return (
        <header className="c-mobileHeader">
            <div className="c-mobileHeader__group">
                <Button variant="ghost" size="md" square onClick={() => dispatch(openEndPresentationAction())}>
                    <img src={NobulaLogoIcon} alt="" />
                </Button>

                {!presentation && <div className="c-header__group_appName">Nobula Case Player</div>}

                {presentation && (
                    <div className="c-mobileHeader__group_titleContainer">
                        <h2 className="">{presentation?.name}</h2>
                        {tabletScreenSize && (
                            <div>
                                {showTimer && <Timer />}
                                <Points />
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div className="c-mobileHeader__group c-mobileHeader__group--noShrink">
                {hasPresActions && showLeaderboard && (
                    <div className="c-mobileHeader__group_icon">
                        <LeaderBoard />
                    </div>
                )}

                <div className="c-mobileHeader__group_icon">
                    <HeaderMenu hasPresActions={hasPresActions} inLobby={inLobby} />
                </div>
            </div>
        </header>
    );
}

export default MobileHeader;
